import React, { useState } from 'react';
import "./style.css"
import { Collapse } from 'react-collapse'
//import { AiOutlineSearch } from 'react-icons/ai'
//import { NavLink } from 'react-router-dom'
import { IoIosArrowDown } from "react-icons/io";
import SideNav from './../../../components/SideNav_OG';
import CadastrosInstituicoes from './../../../components/Display_Organizador/Listar_Cadastros/Instituicoes';
import CadastrosProfissionais from './../../../components/Display_Organizador/Listar_Cadastros/Profissionais';

export default function Tela_Cadastros() {
    //let [search, setSearch] = useState(false);
    let [options, setOptions] = useState(false);
    let [options2, setOptions2] = useState(false);


    return (
        <>
            <SideNav />
            <div id="top-Consulta"></div>

            <div id="main-Consulta">
                    <p id="Consulta">Instituições Cadastradas</p>
                    <hr id="divider-Consulta" />
                    <div id="arrow-Consulta">
                        <IoIosArrowDown
                            onClick={() =>
                                setOptions(!options)
                            }
                            size={"6vh"}
                            id="IconDown-Consulta"
                        />
                    </div>
                    <Collapse isOpened={options}>
                        <div id="collapsed-Consulta">
                        <CadastrosInstituicoes />
                         </div>
                    </Collapse>     
 
                    <p id="Consulta">Profissionais Cadastrados</p>
                    <hr id="divider-Consulta" />
                    <div id="arrow-Consulta2">
                        <IoIosArrowDown
                            onClick={() =>
                                setOptions2(!options2)
                            }
                            size={"6vh"}
                            id="IconDown-Consulta"
                        />
                    </div>
                    <Collapse isOpened={options2}>
                        <div id="collapsed-Consulta2">
                            <CadastrosProfissionais />
                        </div>
                    </Collapse>
            </div>
        </>
    );
}